
const formatThousands = (amount: number) => new Intl.NumberFormat('es-ES').format(amount);

export { formatThousands };